import React from 'react';

    const ProductCardSkeleton = ({ viewMode = 'grid' }) => {
      if (viewMode === 'list') {
        return (
          <div className="bg-white rounded-lg shadow-sm overflow-hidden flex animate-pulse">
            <div className="w-48 flex-shrink-0 h-full bg-gray-200"></div>
            <div className="p-6 flex-1 space-y-4">
              <div className="h-4 bg-gray-200 rounded w-1/4"></div>
              <div className="h-6 bg-gray-300 rounded w-3/4"></div>
              <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6"></div>
              </div>
              <div className="h-5 bg-gray-300 rounded w-1/3 pt-4"></div>
            </div>
          </div>
        );
      }

      return (
        <div className="bg-white rounded-lg shadow-sm overflow-hidden animate-pulse">
          <div className="w-full h-48 bg-gray-200"></div>
          <div className="p-6 space-y-4">
            <div className="h-4 bg-gray-200 rounded w-1/3"></div>
            <div className="h-6 bg-gray-300 rounded w-4/5"></div>
            <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6"></div>
            </div>
            <div className="h-5 bg-gray-300 rounded w-1/3 pt-4"></div>
          </div>
        </div>
      );
    };

    export default ProductCardSkeleton;